import React, {Component} from 'react';
import {injectIntl} from 'react-intl';

class TimeLogInstallResultView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			something: '',
		};
	}

	close() {
		this.props.close();
	}

	render() {
		const linkedUsers = this.props.timeLogInitialUserMappingResponse.filter(u => u.linked);
		const notLinkedUsers = this.props.timeLogInitialUserMappingResponse.filter(u => !u.linked);

		return (
			<div className="layer">
				<div className="fullscreen fullscreen-centered-outer timelog-errors">
					<div className="fullscreen-centered-inner">
						<div className="fullscreen-centered-content">
							{linkedUsers && linkedUsers.length > 0 ? (
								<div>
									<h1>Følgende brugere fra TimeLog er succesfuldt linket til en bruger i Forecast.</h1>
									{linkedUsers.map(r => {
										return (
											<h2>
												{r.timeLogFirstName +
													' ' +
													r.timeLogLastName +
													' - ' +
													r.timeLogEmail +
													' (TimeLog ID: ' +
													r.timeLogPersonId +
													')'}
											</h2>
										);
									})}
								</div>
							) : null}
							{notLinkedUsers && notLinkedUsers.length > 0 ? (
								<div className="timelog-result-content">
									<h1>Følgende brugere fra TimeLog kunne ikke automatisk linkes til en bruger i Forecast.</h1>
									<h1>Her skal du manuelt linke disse brugere under medarbejderlisten.</h1>
									{notLinkedUsers.map(r => {
										return (
											<h2>
												{r.timeLogFirstName +
													' ' +
													r.timeLogLastName +
													' - ' +
													r.timeLogEmail +
													' (' +
													r.timeLogPersonId +
													')'}
											</h2>
										);
									})}
								</div>
							) : null}
							<button className="timelog-ok-button" onClick={this.close.bind(this)}>
								Ok
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default injectIntl(TimeLogInstallResultView);
